import React from "react";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

type SelectorDropdownLayoutProps = {
    dropdownId: string;
    containerRef: React.RefObject<HTMLDivElement>;
    label?: string;
    containerClassName?: string;
    transparent?: boolean;
    inputClass: string;
    rect: DOMRect | false;
    displayValue?: string;
    placeholder?: string;
    iconL?: FontAwesomeIconProps["icon"];
    primary?: boolean;
    onOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
    containerProps?: React.HTMLAttributes<HTMLDivElement>;
};

function SelectorDropdownLayout({
    dropdownId,
    containerRef,
    label,
    containerClassName,
    transparent,
    inputClass,
    rect,
    displayValue,
    placeholder,
    iconL,
    primary,
    onOpen,
    containerProps,
}: SelectorDropdownLayoutProps) {
    const valueToShow = displayValue ?? placeholder ?? "";
    const hasTransparentLayout = Boolean(transparent && containerClassName);
    const iconButtonClassName = `absolute right-3 inset-y-0 flex items-center${transparent ? " pointer-events-auto" : ""}`;
    const rootClassName = hasTransparentLayout
        ? containerClassName
        : `relative w-full${containerClassName ? ` ${containerClassName}` : ""}`;

    const buttonContent = (
        <>
            <button
                onClick={onOpen}
                className={inputClass}
                type="button"
                aria-haspopup="dialog"
                aria-expanded={!!rect}
            >
                <span className="truncate">{valueToShow}</span>
            </button>
            {!iconL && (
                <button
                    type="button"
                    onClick={onOpen}
                    aria-label={placeholder}
                    className={iconButtonClassName}
                >
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        className={`w-4 h-4 ${primary ? "!text-primary" : "text-font dark:text-font-dark"}`}
                    />
                </button>
            )}
            {!!iconL && (
                <span className="absolute left-3 inset-y-0 flex items-center pointer-events-none">
                    <FontAwesomeIcon icon={iconL} className="w-4 h-4 text-font dark:text-font-dark" />
                </span>
            )}
        </>
    );

    return (
        <div
            className={rootClassName}
            id={dropdownId}
            ref={containerRef}
            {...containerProps}
        >
            {!!label && <span className="font-semibold text-xs mb-1">{label}</span>}
            {hasTransparentLayout ? (
                buttonContent
            ) : (
                <div className="relative w-full">
                    {buttonContent}
                </div>
            )}
        </div>
    );
}

export default React.memo(SelectorDropdownLayout);

